// Generated by Claude Code
import { Api } from '#core/api/Api.ts'

/** Public password-reset endpoints. Unauthenticated — no access token or company is required. */
export default class PasswordResetApi extends Api<PasswordResetApi> {
    /** Requests a reset link for an email address. Always resolves — the backend never reveals whether the address exists. */
    public async requestReset(email: string): Promise<void> {
        await this.post<{ requested: boolean }>('auth/password-reset/request', { email })
    }

    /** Completes a reset with the emailed token. Throws ApiError 400 for an invalid/expired token, 422 for a policy violation. */
    public async confirmReset(token: string, password: string): Promise<void> {
        await this.post<void>('auth/password-reset/confirm', { token, password })
    }
}
